'use client';

import HeartIcon from 'components/_other/icons/HeartIcon';
import Link from 'next/link';
import useWishlist from '@/grandus-lib/hooks/v2/useWishlist';

const ItemWishlist = ({}) => {
  const { wishlist } = useWishlist();
  const productIds = wishlist?.productIds || [];

  return (
    <Link href="/oblubene" className="relative">
      <HeartIcon className={'text-black dark:text-beige'} />
      {productIds?.length > 0 ? (
        <div className="absolute w-[18px] h-[18px] text-xs block -top-2 -end-2 rounded-full bg-primary bg-primary dark:bg-beige text-white dark:text-black">
          <div
            className={
              'absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]'
            }
          >
            {productIds?.length ?? 0}
          </div>
        </div>
      ) : (
        ''
      )}
    </Link>
  );
};

export default ItemWishlist;
